module.exports = __webpack_public_path__ + "assets/img/mecha-btn-b170c036.png";